import PDMPlpPromotion from "@tw/product-discovery-merchandizing-cra/lib/plp/promotion/promotion-master-next";
import PageWrapper from "../wrappers/page-wrapper";

PDMPlpPromotion.domainName = "product-discovery";
export default PageWrapper(PDMPlpPromotion);
